import React from "react";
import AppMenu from "../../../layouts/app-menu";
import LeftButton from "./LeftButton";
import { VstLocales } from "vstui";
import { Button } from "@vitalsource/vstui";
import { createTheme, ThemeProvider } from "@vitalsource/vstui/themes";
import { BookStore, Dispatcher } from "../../flux";
import { Isvg } from "../../components";

const theme = createTheme();

class SettingsPanel extends AppMenu.Component {
  constructor(props) {
    super(props);
    this.state = {
      env: "settings-menu",
      error: null,
      menuPosition: window.innerWidth - 536
    };

    // Refs
    this.panelTitleRef = React.createRef();

    this._downloadOfflineApp = this._downloadOfflineApp.bind(this);
    this._updateLocale = this._updateLocale.bind(this);
    this._resize = this._resize.bind(this);
  }

  _updateLocale(locale) {
    Jigsaw.User.setInfo({ locale }, () => {
      window.location.reload();
    });
  }

  componentDidMount() {
    window.addEventListener("resize", this._resize);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this._resize);
  }

  _resize() {
    Fraction.Helpers.throttle(
      () => {
        this.setState({ menuPosition: window.innerWidth - 536 });
        this.forceUpdate();
      },
      15,
      300,
      "settings-panel-resize"
    );
  }

  _clickLocales() {
    var smallScreen = Fraction.Helpers.isSmallScreen() && window.innerHeight;
    return (
      <VstLocales
        customText={i18n.t("base.language-choice")}
        customX={this.state.menuPosition}
        customY={-1}
        onChange={this._updateLocale}
        selected={i18n.getCurrentLocale()}
        vertical={"top"}
        headerBackButton={<Isvg src="/img/chevron_left_large.svg" />}
        isMobile={smallScreen}
        height={smallScreen || 400}
      />
    );
  }

  appOptions() {
    return [
      {
        id: "store",
        img: null,
        onClick: this._clickStore,
        text: Fraction.Brand.Store.label || i18n.t("global-bar.store"),
        shouldShow: this.shouldShowStore,
        target: "_blank",
        href: Fraction.Brand.Store.url
      },
      {
        id: "analytics",
        img: null,
        onClick: this._clickVstAnalytics,
        text: i18n.t("global-bar.vst-analytics"),
        shouldShow: this.shouldShowVstAnalytics,
        target: "_blank",
        href: "#"
      },
      ...Fraction.Brand.AppMenu.elements.map(element => {
        return {
          id: element.key,
          img: element.customIcon,
          onClick: e => this._clickAppMenuElement(e, element),
          text: element.label,
          shouldShow: () => element.enabled,
          href: element.href,
          target: element.newTab ? "_blank" : false
        };
      })
    ];
  }

  toolOptions() {
    return [
      {
        id: "sharing",
        img: null,
        onClick: this._clickSharing,
        text: i18n.t("main-menu.sharing"),
        shouldShow: this.shouldShowSharing
      },
      {
        id: "highlighters",
        img: null,
        onClick: this._clickHighlighters,
        text: i18n.t("main-menu.highlighters"),
        shouldShow: this.shouldShowHighlighters
      }
    ];
  }

  helpOptions() {
    return [
      {
        id: "support",
        img: null,
        onClick: this._clickSupport,
        text: Fraction.Brand.Support.label || i18n.t("global-bar.support"),
        shouldShow: this.shouldShowSupport,
        target: "_blank",
        href: Fraction.Brand.Support.url
      },
      {
        id: "privacy",
        img: null,
        onClick: this._clickPrivacy,
        text: i18n.t("main-menu.privacy"),
        shouldShow: this.shouldShowPrivacy,
        target: "_blank",
        href: Fraction.Brand.Privacy.url || i18n.t("locations.zendesk-privacy")
      },
      {
        id: "noticeCollection",
        img: null,
        onClick: this._clickNoticeCollection,
        text: i18n.t("main-menu.notice-collection"),
        shouldShow: this.shouldShowNoticeCollection,
        target: "_blank",
        href: i18n.t("locations.zendesk-notice-collection")
      },
      {
        id: "feedback",
        img: null,
        onClick: this._takeSurvey,
        text: i18n.t("global-bar.feedback"),
        shouldShow: this.shouldShowFeedback
      }
    ];
  }

  accountOptions() {
    return [
      {
        id: "usrInfo",
        img: null,
        onClick: this._clickUserInfo,
        text: i18n.t("reader.settings.user-info"),
        shouldShow: this.shouldShowUserInfo,
        target: "_blank",
        href: Fraction.Brand.Locations.AccountCenter
      },
      {
        id: "cptAcct",
        img: null,
        onClick: this._completeAccount,
        text: i18n.t("reader.settings.cptAcct"),
        shouldShow: this.shouldShowCompleteAccount,
        href: "/user/sso"
      },
      {
        id: "devices",
        img: null,
        onClick: this._clickDevices,
        text: i18n.t("main-menu.devices"),
        shouldShow: this.shouldShowDevices,
        target: "_blank",
        href: Fraction.Brand.Locations.Devices
      },
      {
        id: "print",
        img: null,
        onClick: this._clickPOD,
        text: i18n.t("main-menu.print-on-demand"),
        shouldShow: this.shouldShowPOD,
        target: "_blank",
        href: "/#/print-on-demand"
      },
      {
        id: "language",
        img: null,
        onClick: this._clickLocales,
        text: i18n.t("base.language-choice"),
        shouldShow: false
      },
      {
        id: "signout",
        img: null,
        onClick: this._logOut,
        text: i18n.t("reader.settings.signout"),
        shouldShow: this.shouldShowLogout,
        href: Fraction.Brand.Locations.signout_redirect
      }
    ];
  }

  _downloadOfflineApp(e) {
    this._launchInApp(e);
    Fraction.Reporter.gaEvent(
      `V3/${this.state.env}/read-offline`,
      "",
      "downloadAppFromSettings"
    );
  }

  renderThemedButton(settingsItem) {
    return (
      <ThemeProvider theme={theme}>
        <LeftButton {...settingsItem}>{settingsItem.text}</LeftButton>
      </ThemeProvider>
    );
  }

  _buildOptions(options) {
    let userSettings = options.map(settingsItem => {
      if (settingsItem.shouldShow && settingsItem.shouldShow()) {
        var themedButton = this.renderThemedButton(settingsItem);
        return (
          <li
            key={settingsItem.id}
            id={"settings-" + settingsItem.id}
            className="settings-btn"
          >
            {themedButton}
          </li>
        );
      } else if (settingsItem.id === "language") {
        return (
          <li key={settingsItem.id} id={"settings-" + settingsItem.id}>
            {this._clickLocales()}
          </li>
        );
      }
    });
    return userSettings;
  }

  renderUserInfo() {
    if (this.shouldShowUserInfo()) {
      return [
        <div id="name">
          {Fraction.User.firstName + " " + Fraction.User.lastName}
        </div>,
        <div id="email">{Fraction.User.email}</div>
      ];
    }
    return null;
  }

  renderReadOffline() {
    if (this.shouldShowReadOffline()) {
      const font = { typography: { fontWeight: 400 } };
      return (
        <div id="settings-read-offline">
          <Isvg id="read-offline" src="/img/settings_read_offline.svg" />
          <ThemeProvider theme={font}>
            <Button
              naked
              className="offline-btn"
              onClick={this._downloadOfflineApp}
            >
              {i18n.t("sso.read-offline-the")}
            </Button>
          </ThemeProvider>
        </div>
      );
    }
    return null;
  }

  render() {
    return (
      <div id="settings-panel">
        <div id="settings-header" className="header">
          <h2 id="panel-header-settings" tabIndex={-1} ref={this.panelTitleRef}>
            {i18n.t("reader.panels.settings")}
          </h2>
          <Button
            className="panel-close-button"
            onClick={() => {
              Dispatcher.emit(Dispatcher.TOGGLE_PANEL, "settings");
            }}
            naked
          >
            <span>
              {i18n.t("reader.panels.close-panel", {
                panelName: i18n.t("reader.panels.settings")
              })}
            </span>
          </Button>
        </div>
        <div id="settings-panel-content">
          {this.renderUserInfo()}
          <h3 className="settings-section">{i18n.t("base.account-plain")}</h3>
          <ul className="settings-options">
            {this._buildOptions(this.accountOptions())}
          </ul>
          <h3 className="settings-section">{i18n.t("global-bar.tools")}</h3>
          <ul className="settings-options">
            {this._buildOptions(this.toolOptions())}
          </ul>
          <h3 className="settings-section">{i18n.t("global-bar.apps")}</h3>
          <ul className="settings-options">
            {this._buildOptions(this.appOptions())}
          </ul>
          <h3 className="settings-section">{i18n.t("base.help")}</h3>
          <ul className="settings-options">
            {this._buildOptions(this.helpOptions())}
          </ul>
        </div>
        {this.renderReadOffline()}
      </div>
    );
  }
}

const gadgetId = "settings";
module.exports = {
  class: SettingsPanel,
  metadata: () => {
    return {
      id: gadgetId,
      name: i18n.t(`reader.panels.${gadgetId}`),
      learnMore: false,
      toggle: false,
      hideHeader: true,
      expanded: false,
      type: "panel",
      enabled: () => Fraction.Brand.Sidebar.Buttons.settings,
      sidebar: {
        icon: "/img/settings.svg",
        action: isbn => {
          const book = BookStore.get(isbn);
          Dispatcher.emit(Dispatcher.TOGGLE_PANEL, gadgetId);
        }
      }
    };
  }
};
